import DashboardLayout from "../components/DashboardLayout.jsx"; 
import {useNavigate} from "react-router-dom"; 
import axios from "axios";
import Swal from 'sweetalert2'; 
import {useEffect} from "react"; 
const withdrawalMessages = [
  "🚨 Alert: A withdrawal of $500 was made from New York, USA!",
  "💰 Notification: $300 has been withdrawn from London, UK.",
  "🌍 Heads up: A user in Tokyo, Japan just withdrew $700.",
  "⚠️ Attention: $450 has been taken out from Sydney, Australia.",
  "💸 Notice: A withdrawal of $200 occurred in Berlin, Germany.",
  "🔔 Alert: $1,200 withdrawn from Toronto, Canada!",
  "💵 Update: A user in Paris, France withdrew $600.",
  "📉 Warning: $400 has been withdrawn from Madrid, Spain.",
  "🏦 Notification: $800 taken out from Singapore.",
  "🚀 Heads up: A $1,000 withdrawal from Dubai, UAE.",
  "💳 Alert: A user in Mumbai, India just withdrew $250.",
  "🌐 Update: $750 has been withdrawn from Johannesburg, South Africa.",
  "📈 Notice: $300 withdrawn from Seoul, South Korea.",
  "🛑 Alert: $900 taken out from Sao Paulo, Brazil.",
  "🏙️ Notification: A user in Mexico City withdrew $350.",
  "📊 Heads up: $650 has been withdrawn from Rome, Italy.",
  "🤑 Attention: A withdrawal of $2,000 from Bangkok, Thailand!",
  "💸 Update: $850 taken out from Istanbul, Turkey.",
  "🎉 Alert: $1,500 withdrawn from Amsterdam, Netherlands.",
  "📣 Notification: $400 has been taken out from Vienna, Austria.",
  "🗺️ Notice: A user in Warsaw, Poland withdrew $600.",
  "🚨 Update: $550 withdrawn from Cairo, Egypt.",
  "💵 Alert: A user in Jakarta, Indonesia just withdrew $300.",
  "🌍 Notification: $2,300 has been withdrawn from Lagos, Nigeria.",
  "💰 Heads up: $1,100 taken out from Zurich, Switzerland.",
  "📈 Attention: A withdrawal of $950 from Nairobi, Kenya.",
  "🧳 Update: $700 withdrawn from Lisbon, Portugal.",
  "📊 Alert: $450 taken out from Athens, Greece.",
  "🏦 Notification: A user in Dubai, UAE withdrew $1,200.",
  "🌐 Notice: $800 has been withdrawn from Helsinki, Finland.",
  "🚀 Heads up: $300 taken out from Oslo, Norway.",
  "🔔 Alert: A withdrawal of $600 from Prague, Czech Republic.",
  "📉 Notification: $500 withdrawn from Budapest, Hungary.",
  "💳 Attention: $700 has been taken out from Tel Aviv, Israel.",
  "🏙️ Update: $400 withdrawn from Dublin, Ireland.",
  "💸 Notice: A user in Caracas, Venezuela just withdrew $1,000.",
  "📣 Heads up: $200 has been withdrawn from Manila, Philippines.",
  "🤑 Alert: A withdrawal of $300 from Taipei, Taiwan.",
  "📊 Notification: $1,800 taken out from Santiago, Chile.",
  "🔔 Update: $950 withdrawn from Boston, USA.",
  "🌍 Attention: A user in San Francisco withdrew $1,500.",
  "🏦 Notice: $650 has been withdrawn from Seattle, USA.",
  "💰 Heads up: $400 taken out from Austin, USA.",
  "📈 Alert: $2,200 withdrawn from Miami, USA.",
  "🛑 Notification: $1,200 taken out from Washington, D.C.",
  "💳 Update: A user in Los Angeles withdrew $350.",
  "🌐 Notice: $600 has been withdrawn from Vancouver, Canada.",
  "🚀 Heads up: $800 taken out from Montreal, Canada.",
  "🔔 Alert: A withdrawal of $1,100 from Atlanta, USA.",
  "📉 Notification: $1,000 has been withdrawn from Orlando, USA.",
  "💵 Attention: A user in Philadelphia withdrew $400.",
  "🏦 Update: $700 taken out from Denver, USA.",
  "🤑 Notice: $900 withdrawn from Baltimore, USA."
];

const getRandomMessage = () => {
  const randomIndex = Math.floor(Math.random() * withdrawalMessages.length);
  return withdrawalMessages[randomIndex];
};

const Dashboard = ()=> {
 useEffect(() => {
    const showWithdrawalAlert = () => {
      Swal.fire({
        title: 'Withdrawal Alert!',
        text: getRandomMessage(),
        icon: 'info',
        showCloseButton: false,
        showCancelButton: false,
        timer: 5000, // Auto-dismiss after 5 seconds
        timerProgressBar: true,
        customClass: {
          popup: 'bg-gray-800 text-white rounded-lg shadow-lg',
          title: 'text-xl font-semibold',
          htmlContainer: 'text-lg',
          closeButton: 'hidden', // Hide the close button
        },
      });
    };

    const intervalId = setInterval(showWithdrawalAlert, 20000); // Show every 60 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);
 
    return(
	 <>
		<DashboardLayout />
	 </>
  ); 
}
export default Dashboard; 
